import { InputLabel } from "@flat-ui";
import { Stack } from "@mui-wrapper";

export interface UlmInputLabelProps {
  /**
   * The title that will be shown on the left side of the component.
   */
  title: string;

  /** Whether the field is disabled, which flat-ui's label shows in its disabled colour */
  isDisabled?: boolean;

  /** Optional component to show on the right side of the label */
  helpComponent?: React.ReactNode;
}

/**
 * Renders a label that can be used in forms.
 * The component takes the full width of the parent: flat-ui's `InputLabel` on the left, and the
 * optional help component (a link, a help icon) on the right.
 */
export function UlmInputLabel({
  title,
  isDisabled = false,
  helpComponent,
}: UlmInputLabelProps): JSX.Element {
  return (
    <Stack
      direction="row"
      sx={{
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        marginBottom: "2px",
      }}
    >
      <InputLabel disabled={isDisabled}>{title}</InputLabel>
      {helpComponent}
    </Stack>
  );
}
